<template>
  <div class="regulations">
    <div class="regulations-detail">
      <div class="regulations-header-box">
        <div class="regulations-header-left">政策法规</div>
        <div class="regulations-header-right" @click="goBack">返回</div>
      </div>
      <div class="regulations-content" v-if="flag">
        <div class="regulations-content-title">{{content.title}}</div>
        <div class="regulations-content-title1">
          <span>{{content.createTime}}</span>
          <span style="margin-left: 10px;">{{content.createOrgName}}</span>
        </div>
        <div class="regulations-content-box" v-html="content.content"></div>
        <div v-if="hasAttachmentList">
          <ul>
            <li v-for="item in content.attachmentList" :key="item.id">
              <el-button
                type="text"
                v-if="isWord(item.suffix.toLowerCase())"
                @click="handleNewPreview(item.id)"
              >{{item.fileName}}</el-button>
              <el-button
                type="text"
                v-if="isPic(item.suffix.toLowerCase())"
                @click="getPhotoNewAlbums(item.id)"
              >{{item.fileName}}</el-button>
              <el-button
                type="text"
                v-if="item.suffix.toLowerCase() === 'pdf'"
                @click="previewNewPdf(item.id)"
              >{{item.fileName}}</el-button>
              <el-button
                size="mini"
                type="text"
                v-if="isWord(item.suffix.toLowerCase())"
                @click="handleNewPreview(item.id)"
              >预览</el-button>
              <el-button
                size="mini"
                type="text"
                v-if="isPic(item.suffix.toLowerCase())"
                @click="getPhotoNewAlbums(item.id)"
              >预览</el-button>
              <el-button
                size="mini"
                type="text"
                v-if="item.suffix.toLowerCase() === 'pdf'"
                @click="previewNewPdf(item.id)"
              >预览</el-button>
            </li>
          </ul>
        </div>
      </div>
      <div class="regulations-none" v-else>
        <div style="text-align: center;">
          <img src="../../assets/img/company.png" />
          <div style="color:#999999;font-size: 13px;">暂无数据信息</div>
        </div>
      </div>
    </div>
    <gov-pdf-preview
      :visible="pdfVisible"
      :pdf-url="pdfSrc"
      @close="pdfVisible = false"
      :loading="pdfLoading"
    ></gov-pdf-preview>
    <viewer
      :images="images"
      :options="viewOptions"
      :fulled="true"
      @inited="inited"
      style="display: none;"
      class="viewer"
      ref="viewer"
    >
      <template slot-scope="scope">
        <img v-for="src in scope.images" :src="src" :key="src" />
        {{scope.options}}
      </template>
    </viewer>
  </div>
</template>
<script>
import {
  queryPolicyRegulationDetail,
  downloadFile
} from '@/api/publicinquiry.api.js';
import { setSession, getSession } from '@/untils';
import GovPdfPreview from '@/components/common/gov-pdf-preview';
import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer/src/component.vue';
import {
  getImgSrcType,
  getImageIndex,
  decodeURI,
  previewPageOffice,
  getBlob
} from '@/untils';
export default {
  components: {
    Viewer,
    GovPdfPreview
  },
  computed: {
    hasAttachmentList() {
      return this.attachmentList.length > 0;
    }
  },
  data() {
    return {
      pdfVisible: false,
      pdfLoading: false,
      flag: true,
      images: [],
      attachmentList: [],
      id: '',
      content: {},
      viewOptions: {
        // inline: true,
        container: 'body',
        backdrop: true,
        button: true
      },
      pdfSrc: ''
    };
  },
  methods: {
    queryPolicyRegulationDetail() {
      queryPolicyRegulationDetail(this.id).then(res => {
        this.content = res.body;
        if (res.body.attachmentList) {
          this.attachmentList = res.body.attachmentList;
        }
      });
    },
    goBack() {
      this.$router.push({ name: 'News' });
    },
    // 初始化完一个预览组件
    inited(viewer) {
      this.viewer = viewer;
      this.$nextTick(() => {
        if (this.images && this.images.length > 0) {
          let index = getImageIndex(this.images, this.imgPreviewURL);
          this.showImg(index);
        }
      });
    },
    // 打开预览组件
    showImg(index) {
      this.viewer.view(index);
    },
    isWord(suffix) {
      const suffixStr = '.xlsx,.xls,.docx,.doc';
      return suffixStr.indexOf(suffix) !== -1;
    },
    isPic(suffix) {
      const suffixStr =
        'gif,.jpg,.pic,.png,.dwg,.dws,.dwt,.dxf,.jpeg,.bmp,.tiff';
      return suffixStr.indexOf(suffix) !== -1;
    },
    handleNewPreview(id) {
      const url = `/report/pageoffice/summary/previewPolicyRegulationAttachment/${id}`;
      previewPageOffice(url);
    },
    getPhotoNewAlbums(id) {
      this.images = [];
      let flag = '1';
      this.imgPreviewURL = decodeURI(`/publicity/sys/downloadFile/${flag}/${id}`);
      this.images.push(this.imgPreviewURL);
    },
    previewNewPdf(id) {
      let flag = '1';
      const url = decodeURI(`/publicity/sys/downloadFile/${flag}/${id}`);
      // let params = {
      //   id: id
      // };
      this.pdfSrc = decodeURI(`/publicity/sys/downloadFile/${flag}/${id}`);
      this.pdfVisible = true;
      this.pdfLoading = true;
      getBlob(url).then(res => {
        this.pdfLoading = false;
      });
    }
  },
  created() {
    this.id = getSession('id');
    this.queryPolicyRegulationDetail();
  }
};
</script>
<style>
.regulations {
  height: 100%;
}
.regulations-detail {
  height: 100%;
  background: #ffffff;
}
.regulations-header-box {
  color: rgb(2, 91, 145);
  text-indent: 15px;
  border-bottom: 2px solid rgb(2, 91, 145);
  height: 40px;
}
.regulations-header-left {
  float: left;
  padding: 5px 0;
  font-size: 20px;
  font-weight: 700;
}
.regulations-header-right {
  line-height: 30px;
  float: right;
  width: 60px;
  height: 30px;
  background: inherit;
  background-color: rgba(2, 91, 145, 1);
  border: none;
  border-top: 0px;
  border-radius: 10px;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
}
.regulations-content {
  padding: 0 50px;
  overflow: auto;
  height: calc(100% - 53px);
}
.regulations-none {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.regulations-content-title {
  text-align: center;
  color: #333333;
  font-weight: 700;
  font-size: 16px;
  line-height: 30px;
}
.regulations-content-title1 {
  text-align: center;
}
.viewer-toolbar ul li:nth-child(5) {
  position: fixed;
  top: 45%;
  left: 15%;
}
.viewer-toolbar ul li:nth-child(7) {
  position: fixed;
  top: 45%;
  right: 15%;
}
.viewer-toolbar > ul > li {
  height: 50px !important;
  width: 50px !important;
}
.viewer-toolbar > ul > .viewer-large {
  height: 60px !important;
  width: 60px !important;
}
.viewer-toolbar > ul > li::before {
  margin: 15px !important;
}
.viewer-toolbar > ul > .viewer-large::before {
  margin: 20px !important;
}
</style>


// WEBPACK FOOTER //
// src/page/regulations/regulationsDetail.vue